import _ from 'lodash'
import querystring from 'querystring'

import { STAGE_STATUS } from 'constants/setupform-constants'

export const getPartnerUrl = (partnerId, fragment = '') => `/p/${partnerId}${fragment}`

export const getEventUrl = (partnerId, eventId, fragment = '') =>
  getPartnerUrl(partnerId, `/event/${eventId}${fragment}`)

export const getSetupformUrl = (partnerId, setupformId = 'new', stage) => {
  const root = `/sf/${setupformId}`
  switch (stage) {
    default:
    case STAGE_STATUS.BASIC_DETAILS:
      return getPartnerUrl(partnerId, root)

    case STAGE_STATUS.CALENDAR:
      return getPartnerUrl(partnerId, `${root}/calendar/`)

    case STAGE_STATUS.ADVANCED_DETAILS:
      return getPartnerUrl(partnerId, `${root}/details/`)

    case STAGE_STATUS.SUMMARY:
      return getPartnerUrl(partnerId, `${root}/summary/`)

    case STAGE_STATUS.VOUCHERS:
      return getPartnerUrl(partnerId, `${root}/vouchers/`)
  }
}

export const getHistoryUrl = (partnerId, dealId) => (
  dealId ? getPartnerUrl(partnerId, `/event/${dealId}/history`) : null
)

export const stringify = (obj) => {
  const query = querystring.stringify(
    _(obj).omitBy(_.isUndefined).value()
  )
  return query ? `?${query}` : ''
}

export const fromTicketing = () => document.referrer.indexOf('/ticketing') > -1

export const isSummary = () => document.location.href.indexOf('/summary') > -1



/** WEBPACK FOOTER **
 ** ./src/utils/urls/urls.js
 **/